<div
  routerLinkActive=""
  #rlaMenu="routerLinkActive"
  class="flex cursor-pointer flex-col gap-1 text-x-small font-bold text-text-000 dark:text-text-700"
  [class.pointer-events-none]="!isSideMenuOpen()"
>
  <div
    class="flex h-12 items-center gap-x-1 rounded px-4 hover:bg-primary-600 dark:hover:bg-primary-400 md:px-3"
    [class.bg-primary-600]="highlightedGroup()"
    [class.dark:hover:bg-primary-400]="highlightedGroup()"
    (click)="onMenuClick(isMenuOpen())"
  >
    <svg-icon [key]="iconKey()" />
    @if (isSideMenuOpen()) {
      <div class="flex-1">{{ label() }}</div>
      <div class="h-6 w-6">
        <svg-icon class="pointer-events-none" [key]="isMenuOpen() ? 'chevron-up-24' : 'chevron-down-24'" />
      </div>
    }
  </div>

  @if (isMenuOpen() && isSideMenuOpen()) {
    <div @openClose class="flex flex-col gap-1 font-medium">
      @for (route of routes(); track route.routeSegments.join('/')) {
        @if (route.permissions) {
          <ng-container *appIfPermission="route.permissions">
            <a
              [routerLink]="route.routeSegments"
              routerLinkActive=""
              #rla="routerLinkActive"
              appSideMenuNestedItemLinkIsActive
              [forcedHighlightState]="route.forcedHighlightState"
              class="flex items-center rounded py-2 pl-11 pr-4 text-x-small font-medium hover:bg-primary-600 dark:hover:bg-primary-400 md:pl-10"
              [ngClass]="
                ((route.forcedHighlightState | sideMenuNestedItemForcedHighlight) ?? rla.isActive)
                  ? ['bg-secondary-500', 'dark:text-text-000', 'dark:hover:bg-secondary-700']
                  : null
              "
              (click)="onLabelClick(route.isShortcut, $event)"
            >
              {{ route.label }}
            </a>
          </ng-container>
        } @else {
          <a
            [routerLink]="route.routeSegments"
            routerLinkActive=""
            #rla="routerLinkActive"
            appSideMenuNestedItemLinkIsActive
            [forcedHighlightState]="route.forcedHighlightState"
            class="flex items-center rounded py-2 pl-11 pr-4 text-x-small font-medium hover:bg-primary-600 dark:hover:bg-primary-400 md:pl-10"
            [ngClass]="
              ((route.forcedHighlightState | sideMenuNestedItemForcedHighlight) ?? rla.isActive)
                ? ['bg-secondary-500', 'dark:text-text-000', 'dark:hover:bg-secondary-700']
                : null
            "
            (click)="onLabelClick(route.isShortcut, $event)"
          >
            {{ route.label }}
          </a>
        }
      }
    </div>
  }

  <!--NOTE: don't remove, this is here to highlight item when menu is closed-->
  @for (route of routes(); track route.routeSegments.join('/')) {
    @if (route.permissions) {
      <ng-container *appIfPermission="route.permissions">
        <a
          class="hidden"
          aria-hidden="true"
          [routerLink]="route.routeSegments"
          routerLinkActive=""
          #rla="routerLinkActive"
          appSideMenuNestedItemLinkIsActive
          [forcedHighlightState]="route.forcedHighlightState"
        ></a>
      </ng-container>
    } @else {
      <a
        class="hidden"
        aria-hidden="true"
        [routerLink]="route.routeSegments"
        routerLinkActive=""
        #rla="routerLinkActive"
        appSideMenuNestedItemLinkIsActive
        [forcedHighlightState]="route.forcedHighlightState"
      ></a>
    }
  }
</div>
